var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoneyBag = function SvgMoneyBag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "money_bag_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#money_bag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 20a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 12.5 17.5q0-1.03.734-1.766A2.4 2.4 0 0 1 15 15q1.032 0 1.766.734.734.735.734 1.766t-.734 1.766T15 20M9.219 8.75H20.78l1.594-3.187a1.19 1.19 0 0 0-.047-1.22q-.36-.593-1.078-.593H8.75q-.72 0-1.078.594a1.19 1.19 0 0 0-.047 1.218zm1.281 17.5h9q2.813 0 4.781-1.953 1.97-1.953 1.969-4.797a6.8 6.8 0 0 0-.406-2.312 6.8 6.8 0 0 0-1.157-2.032l-3.25-3.906H8.563l-3.25 3.906a6.8 6.8 0 0 0-1.156 2.031q-.405 1.125-.406 2.313 0 2.844 1.953 4.797T10.5 26.25"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoneyBag);
export default ForwardRef;